import script from "./SsoButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SsoButton.vue?vue&type=script&setup=true&lang=js"

import "./SsoButton.vue?vue&type=style&index=0&id=07efd78e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07efd78e"]])

export default __exports__